"use client";
import { jsxs as r, jsx as a } from "react/jsx-runtime";
const n = ({
  title: l,
  titleId: e,
  desc: i,
  descId: s,
  ...c
}) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": e,
    "aria-describedby": s,
    ...c,
    children: [
      i ? /* @__PURE__ */ a("desc", { id: s, children: i }) : null,
      l ? /* @__PURE__ */ a("title", { id: e, children: l }) : null,
      /* @__PURE__ */ a(
        "path",
        {
          fill: "currentColor",
          stroke: "#EBF8FF",
          strokeWidth: 0.4,
          d: "M3.3111 20.7639v-5.3556H20.689v5.3556a.911.911 0 0 1-.9111.9111.911.911 0 0 1-.9111-.9111v-3.5333H5.1333v3.5333a.911.911 0 0 1-.911.9111.911.911 0 0 1-.9112-.9111Zm.3556-6.8667c-.4106 0-.753-.1414-1.0392-.4275S2.2 12.8411 2.2 12.4306c0-.4106.1414-.753.4275-1.0392s.6286-.4275 1.0392-.4275.753.1414 1.0391.4275.4275.6286.4275 1.0392-.1414.7529-.4275 1.0391-.6286.4275-1.0391.4275Zm4.0777 0c-.6075 0-1.1-.4925-1.1-1.1v-8.7c0-.5576.1963-1.03.5942-1.428.398-.398.8704-.5942 1.428-.5942h6.6667c.5577 0 1.0301.1962 1.4281.5942s.5942.8704.5942 1.428v8.7c0 .6075-.4925 1.1-1.1 1.1zm12.5889 0c-.4105 0-.753-.1414-1.0391-.4275s-.4275-.6286-.4275-1.0391c0-.4106.1414-.753.4275-1.0392s.6286-.4275 1.0391-.4275c.4106 0 .753.1414 1.0392.4275s.4275.6286.4275 1.0392-.1414.7529-.4275 1.0391-.6286.4275-1.0392.4275ZM8.4667 11.575a.5.5 0 0 0 .5.5h6.0666a.5.5 0 0 0 .5-.5V4.3972a.5.5 0 0 0-.5-.5H8.9667a.5.5 0 0 0-.5.5z"
        }
      )
    ]
  }
);
export {
  n as default
};
